module.exports = __webpack_public_path__ + "img/Thyroidcollar.8aa31a89.png";